import { render } from "./Modal.vue?vue&type=template&id=cd20a5be&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=cd20a5be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cd20a5be"

export default script